import { render } from "./LandingEmpezarView.vue?vue&type=template&id=313bb566&scoped=true"
import script from "./LandingEmpezarView.vue?vue&type=script&lang=js"
export * from "./LandingEmpezarView.vue?vue&type=script&lang=js"

import "./LandingEmpezarView.vue?vue&type=style&index=0&id=313bb566&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313bb566"]])

export default __exports__